interface HeaderMetric {
  delayTag?: unknown
  tooltipContents?: unknown
}

export function resolveTooltipContents(metric: HeaderMetric | undefined, data: object | undefined): unknown {
  if (!metric?.tooltipContents) return null
  return typeof metric.tooltipContents === "function" ? metric.tooltipContents(data || {}) : metric.tooltipContents
}

export function hasInfoIcon(metric: HeaderMetric | undefined, data: object | undefined): boolean {
  return Boolean(resolveTooltipContents(metric, data))
}

export function hasStackedHeaderIcons(metric: HeaderMetric, data: object | undefined): boolean {
  return Boolean(metric.delayTag) && hasInfoIcon(metric, data)
}
